import React from 'react'
import { Typography,Grid} from '@mui/material';
import colors from '../../../colors';
import ListItemButton from '@mui/material/ListItemButton';
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData, setCardOnFilePaymentValue} from '../../../../features/userInfo/topUpSlice'

const SingleCard = (props) => {
  const topUpDataSliceState = useSelector(selectTopUpData)
  const isSelected = props.cardInfo.cardID === topUpDataSliceState.selectedCard

  return (
      <Grid container item md={12} xs={12} mt={-1} >
        <ListItemButton selected={isSelected} sx={{width:'100%', height:'40px', borderRadius:'5px', backgroundColor:colors.white, border:isSelected ? '1px solid orange' : '1px solid #F0F0F0'}} onClick={props.onClick}>
            <Grid container mt={-0.5} mb={-0.5} >
              <Grid container item md={12} xs={12} justifyContent="center" alignContent={'center'} >
                <Grid container item md={12} xs={12} >
                  <Typography sx={{fontFamily:'GerberaMedium', fontSize:'0.7rem', color:colors.darkBlue}} >{props.cardInfo.cardNumber}</Typography>
                </Grid>
                <Grid container item md={12} xs={12} >
                  <Typography sx={{fontFamily:'GerberaLight', fontSize:'0.7rem', color:colors.gray}} >{props.cardInfo.cardExpire}</Typography>
                </Grid>
              </Grid>
            </Grid>
        </ListItemButton>
      </Grid>
  )
}

export default SingleCard